import * as api_urls from './../config/api_urls';
import * as UserActions from './../actions/user_actions';
import * as ReportActions from './../actions/report_actions';
import * as SettingScreen from './../actions/settingScreen_actions';

import * as DashboardActions from './../actions/dashboard_actions';
import * as QuestionnaireActions from './../actions/questionnaire_actions';
import * as FacilitiesActions from './../actions/facilities_actions';

import * as PatientsActions from './../actions/admin/patients_actions';
import * as AdminDashboardActions from './../actions/admin/dashboard_actions';
import * as AdminSettingAactions from './../actions/admin/adminSetting_action';
import * as ReasonActions from './../actions/reason_actions';

//tickets
import * as TicketsActions from './../actions/ticket_actions'


export var success_manager = (dispatch, endpointUrl, payload, response, endpoint) => {

    endpointUrl = endpointUrl.indexOf('?') !== -1 ? endpointUrl.substring(0, endpointUrl.indexOf('?')) : endpointUrl;

    switch (endpoint) {
        case api_urls.MULTI_FACILITY_REQUEST: {
            multi_facility_request(dispatch, response);
        };
            break;
        case api_urls.EXPORT_DATA: {
            exportData(dispatch, response);
        }; break;
        case api_urls.VERIFY_OTP: {
            otpSuccess(dispatch, response);
        }; break;
        case api_urls.TICKETS_List: {
            ticketsList(dispatch, response)
        };
            break;

        case api_urls.TRIGGER_OTP: {
            triggerOTP(dispatch, response);
        }; break;
        case api_urls.TICKETS_CONVERSTION: {
            ticketsConverstionList(dispatch, response)
        };
            break;


        case api_urls.TICKETS_CONVERSTION_REPLY: {
            ticketsConverstionListReply(dispatch, response, payload)
        };
            break;


        case api_urls.TICKETS_STAUTS: {
            status(dispatch, response)
        }; break;

        case api_urls.OTP_VERIFY: {
            status(dispatch, response)
        };
            break;

        case api_urls.LOGIN:
            {
                login(dispatch, response);
            };
            break;
        case api_urls.FORGOT_USER_NAME:
            {
                forgotusername(dispatch, response);
            };
            break;
        case api_urls.FORGOT_PASSWORD:
            {
                forgotpassword(dispatch, response);
            };
            break;
        // Response of verify answers of security questions
        case api_urls.VERIFY_SECURITY: {
            securityQuestionVerify(dispatch, response);
        }
            break;
        // commented by Raju
        // case api_urls.SECURITY_QUESTIONS:
        //     {
        //         securityQuestion(dispatch, response);
        //     };
        //     break;

        //  To set Response of previously user selected security questions
        // Calls the function in Settings Action
        case api_urls.GET_SECURITY_QUESTION:
            {
                getSecurQuesiton(dispatch, response);
            };
            break;

        case api_urls.CHANGE_PASSWORD:
            {
                getChangePassResponse(dispatch, response);
            };
            break;
        case api_urls.REGISTRATION_PROFILE_UPDATE:
            {
                Profile_Update(dispatch, response);
            };
            break;
        case api_urls.PROFILE_UPDATE:
            {
                Profile_Update(dispatch, response);
            };
            break;
        case api_urls.PASS_VERIFICATION: {
            verify_pass(dispatch, response);
        }
            break;
        case api_urls.DASHBOARD_DETAILS:
            {
                dashboard(dispatch, response);
            };
            break;
        case api_urls.NOTIFICATIONS_DETAILS:
            {
                notifications(dispatch, response);
            };
            break;
        case api_urls.QUESTIONNAIRE_DETAILS:
            {
                questionnaire(dispatch, response);
            };
            break;
        // need to remove, will be deprecated. now using "GET_FACILITIES_BY_SEARCH" api instead of this.
        case api_urls.GET_ALL_FACILITY:
            {
                getgetFaclity(dispatch, response);
            };
            break;
        case api_urls.CREATE_FACILITY:
            {
                createFaclity(dispatch, response);
            };
            break;
        case api_urls.ANSERTYPE_DETAILS:
            {
                answerType(dispatch, response);
            };
            break;
        // Wrote the new case:  case api_urls.UPDATE_SECURITY_QUESTIONS:
        // case api_urls.UPDATE_QUESTIONS:
        //     {
        //         securityUpdate(dispatch, response);
        //     };
        //     break;
        case api_urls.CREATE_UNIQUE:
            {
                createUnique(dispatch, response);
            };
            break;
        case api_urls.UPDATE_FACILITY:
            {
                updateFaclity(dispatch, response);
            };
            break;
        case api_urls.GET_FACILITY_BY_ID:
            {
                getFaclitybyId(dispatch, response);
            };
            break;
        case api_urls.ADD_FACILITY_ADMIN:
            {
                addFaclitybyAdmin(dispatch, response);
            };
            break;
        case api_urls.GET_ADMIN_USER_BY_ID:
            {
                getFacilityAdmin(dispatch, response);
            };
            break;


        case api_urls.GET_FACILITIES_BY_SEARCH:
            {
                getfacilitiesbySearch(dispatch, response);
            };
            break;
        case api_urls.QUESTIONS_UPDATE:
            {
                questionUpdate(dispatch, response);
            };
            break;
        case api_urls.ACTIVATE_FACILITY_ADMIN:
            {

                activatefacilityadmin(dispatch, response);
            };
            break;
        case api_urls.DEACTIVATE_FACILITY_ADMIN:
            {

                deactivatefacilityadmin(dispatch, response);
            };
            break;
        case api_urls.DEACTIVATE_FACILITY:
            {
                deactivatefacility(dispatch, response);
            };
            break;

        case api_urls.FACILITY_IMAGE_UPLOAD:
            {
                if (endpointUrl.includes('CLINIC')) {
                    uploadFacilityImage(dispatch, response);
                } else if (endpointUrl.includes('USER')) {
                    userProfile(dispatch, response);
                }
            };
            break;
        case api_urls.DELETEUNIQUEQS:
            {
                deleteUniqewQs(dispatch, response);
            };
            break;

        //Registration
        case api_urls.GET_HEIGHEST_DEGREES:
            {
                getHighestDegrees(dispatch, response);
            };
            break;
        case api_urls.GET_PROFESSIONAL_ROLES:
            {
                getProfessionalRoles(dispatch, response);
            };
            break;
        case api_urls.GET_ETHNICITIES:
            {
                getEthnicities(dispatch, response);
            };
            break;
        //Admin Users
        // deprecated need to remove
        case api_urls.GET_ALL_PATIENTS_DATA:
            {
                get_patients_data(dispatch, response);
            };
            break;
        // deprecated need to remove
        case api_urls.GET_ALL_STAFF_DATA:
            {
                get_staff_data(dispatch, response);
            };
            break;

        // GET_USERS_BY_ROLE - Replacement of GET_ALL_STAFF_DATA and GET_ALL_PATIENTS_DATA
        case api_urls.GET_USERS_BY_ROLE:
            {
                set_Users_By_Role(dispatch, response);
            };
            break;
        case api_urls.ADMIN_DASHBOARD:
            {
                adminDashboard(dispatch, response);
            };
            break;

        case api_urls.GET_SURVEY_LIST:
            {
                getSurveList(dispatch, response);
            };

            break;
        case api_urls.GET_PATIENT_INFO:
            {
                getPatientinfo(dispatch, response);
            };

            break;
        case api_urls.REDFLAG:
            {
                getRedFlagInfo(dispatch, response);
            };

            break;

        case api_urls.ADMIN_SELECT:

            {
                adminSelect(dispatch, response);
            };
            break;

        case api_urls.ADMIN_REQUEST_TO_DEACTIVATE:
            {
                adminDeactivateUser(dispatch, response);
            };
            break;
        // Response of get all security questions API
        case api_urls.GET_ALL_SECURITY_QUESTIONS:
            {
                setAllSecrityQuestionsResponse(dispatch, response);
            };
            break;
        //Response of get all random security questions API
        case api_urls.GET_ALL_RANDOM_SECURITY_QUESTIONS:
            {
                setAllRandomSecurityQuestionsByIdResponse(dispatch, response);
            };
            break;
        // Response of User selected security questions update API
        case api_urls.UPDATE_SECURITY_QUESTIONS:
            {
                updateSecrityQuestions_Status(dispatch, response);
            };
            break;
        case api_urls.UPDATE_STATUS_STAFF_PATIENT:
            { activateDeactivateStaff(dispatch, response); };
            break;
        case api_urls.GET_THERAPIST_LIST: { gettherpaistlist(dispatch, response) }
            break;
        case api_urls.GET_PSYCHIATRIST_LIST: { getpsychiatristlist(dispatch, response) }
            break;
        case api_urls.USER_TRIGGER_TIME: { triggerTime(dispatch, response) }
            break;

        case api_urls.FILLTER_PATIENT_BY_DR: { filterPatientdata(dispatch, response) }
            break;
        //Response of Patients upload csv
        case api_urls.UPLOAD_PATIENTS_REGISTRATION_CSV: {
            fileUploadRegistration(dispatch, response);
        };
            break;
        //Response of staff upload csv
        case api_urls.UPLOAD_STAFF_REGISTRATION_CSV: {
            fileUploadRegistration(dispatch, response);
        };
            break;
        //patient reports cases
        case api_urls.REPORT_SELF_CARE: {
            send_self_care_data(dispatch, response);
        };
            break;
        case api_urls.REPORT_MYTHOUGHTS: {
            send_mythoughts_data(dispatch, response);
        };
            break;
        case api_urls.REPORT_MYACTIVITY: {
            send_myactivity_data(dispatch, response);
        };
            break;
        case api_urls.REPORT_MYEXPERIENCE: {
            send_myaexperience_data(dispatch, response);
        };
            break;
        //Response of Patients Survery Respose
        case api_urls.PATIENTS_SURVEY_RESPONSE: {
            surveyResponse(dispatch, response);
        };
            break;
        case api_urls.CSV_REPORT_ADMIN: {
            sendCsvReportAdmin(dispatch, response);
        };
            break;
        case api_urls.CSV_REPORT_SUPER_ADMIN: {
            sendCsvReportSuperAdmin(dispatch, response);
        };
            break;
        case api_urls.ACTIVE_FACILITY: {
            sendActiveFacilty(dispatch, response);
        };
            break;
        case api_urls.ADDQUESTIONSTOSURVEY: {
            addquestionToSurvey(dispatch, response);
        };
            break;
        case api_urls.ADMIN_UNIQUE_QUESTION_ALL: {
            adminUniqueQuestionAll(dispatch, response);
        };
            break;
        case api_urls.USER_LOG_OUT: {
            logoutUserSession(dispatch, response);
        };
            break;

        case api_urls.USER_AUTO_LOG_OUT: {
            logoutUserSession(dispatch, response);
        };
            break;
        case api_urls.RESEND_EXPIRED_LINK: {
            setResendLink(dispatch, response);
        };
            break;
        case api_urls.USER_REDFLAG_RESLOVE: {
            resloveRedFlags(dispatch, response);
        };

            // break;
            // case api_urls.GET_SECURE_REASON: {
            //     getReasons(dispatch, response);
            // };
            // case api_urls.GET_PROFESSIONAL_ROLES:
            //     {
            //         getProfessionalRoles(dispatch, response);
            //     };
            break;
        case api_urls.GET_SECURE_REASON: {
            resolvedReasons(dispatch, response);
        };
            break;
        case api_urls.LOGS_LIST: {
            logsList(dispatch, response);
        };
            break;
        case api_urls.POST_LOG: {
            logResponse(dispatch, response);
        };
            break;
        case api_urls.PUT_SECURE_REASON: {
            resolvedPutReason(dispatch, response);
        };
            break;
        case api_urls.HISTORY_LOGS: {
            historyLogs(dispatch, response);
        };
            break;
        case api_urls.USER_DELETE: {
            deleteUserLogs(dispatch, response);
        }; break;
        case api_urls.USER_PROFILE_IMAGE: {
            userProfile(dispatch, response);
        };
            break;
        case api_urls.EXPRESSION_UPDATE: {
            updateQuestionExpression(dispatch, response);
        };
            break;
        case api_urls.WEEKLY_SURVEY_UPDATE: {
            updateWeeklySurvey(dispatch, response);
        };

            break;
        default:
            {
                if (response) {
                    return response;
                } else {
                    return { status: 200, message: 'No data.' };
                }
            }
    }
};

// otp
function otpSuccess(dispatch, response) {
    dispatch(UserActions.otpSuccess(response));
}

function exportData(dispatch, response) {
    dispatch(TicketsActions.exportDataResponse(response))
}
//tickets
function ticketsList(dispatch, response) {
    dispatch(TicketsActions.ticketsData(response))
}


//otptrigger
function triggerOTP(dispatch, response) {
    dispatch(SettingScreen.setOTPData(response))
}

function ticketsConverstionList(dispatch, response) {
    dispatch(TicketsActions.ticketsConverstionData(response))
}



function ticketsConverstionListReply(dispatch, response, payload) {
    if (response) {
        let data = "/" + payload.tkt_id
        dispatch(TicketsActions.getTicketsConverstion(data))
    }
}

function status(dispatch, response) {
    dispatch(TicketsActions.statusData(response))
}

function multi_facility_request(dispatch, response) {
    dispatch(UserActions.MultifacilityRequest_data(response));
}
/*  ----------------Deals Success Handler------------------------------  */
function login(dispatch, response) {
    dispatch(UserActions.logingDetails(response));
}
function forgotusername(dispatch, response) {
    dispatch(UserActions.getUserName(response));
}
function forgotpassword(dispatch, response) {
    dispatch(UserActions.userPasswordDetail(response));
}

// commented by Raju
// function securityQuestion(dispatch, response) {
//     dispatch(UserActions.secQuestion(response.data));
// }

function securityUpdate(dispatch, response) {
    dispatch(UserActions.updateQuestion(response));
}
function getSurveList(dispatch, response) {
    dispatch(UserActions.survey_list_data(response));
}

function getSecurQuesiton(dispatch, response) {
    dispatch(SettingScreen.getSecurQuesitonData(response.data));
}

function getChangePassResponse(dispatch, response) {
    dispatch(SettingScreen.ChangePassResponse(response));
}
function Profile_Update(dispatch, response) {
    dispatch(SettingScreen.Profile_Update(response));
}
function verify_pass(dispatch, response) {
    dispatch(SettingScreen.VerifyPassResponse(response))
}

function sendActiveFacilty(dispatch, response) {

    dispatch(DashboardActions.active_facilty_data(response));

}
// need to remove, will be deprecated. now using "GET_FACILITIES_BY_SEARCH" api instead of this.
function getgetFaclity(dispatch, response) {

    dispatch(FacilitiesActions.FacilityDetails(response));
}

// get facilities by search response
function getfacilitiesbySearch(dispatch, response) {
    // binded the getfacilitybysearch api to facility details api
    dispatch(FacilitiesActions.FacilityDetails(response));
}

function createFaclity(dispatch, response) {

    dispatch(FacilitiesActions.AddedFacility(response));
}
function updateFaclity(dispatch, response) {

    dispatch(FacilitiesActions.facilityUpdate(response));
}
function getFaclitybyId(dispatch, response) {

    dispatch(FacilitiesActions.FacilityDetailsByID(response));
}

function dashboard(dispatch, response) {

    dispatch(DashboardActions.dashboardData(response.data));
}
function notifications(dispatch, response) {

    dispatch(DashboardActions.notificationsData(response.data));
}
function questionnaire(dispatch, response) {

    dispatch(QuestionnaireActions.questionnaireData(response.data));
}
function answerType(dispatch, response) {

    dispatch(QuestionnaireActions.answerTypeData(response.data));
}

function securityQuestionVerify(dispatch, response) {
    dispatch(UserActions.verifyAnswers(response))
}

// function securityUpdate(dispatch, response) {
//     dispatch(UserActions.updateQuestion(response));
// }

function createUnique(dispatch, response) {

    dispatch(QuestionnaireActions.createUniqueDate(response));
    dispatch(QuestionnaireActions.questionnaire());

}
function addFaclitybyAdmin(dispatch, response) {
    dispatch(FacilitiesActions.addFacilityAdmin(response));
}

function getFacilityAdmin(dispatch, response) {
    dispatch(FacilitiesActions.getAdminUser(response));
}

function questionUpdate(dispatch, response) {
    dispatch(QuestionnaireActions.qusUpDateData(response.data));
}
function activatefacilityadmin(dispatch, response) {
    dispatch(FacilitiesActions.activate_facilty_admin(response));
}
function deactivatefacilityadmin(dispatch, response) {
    dispatch(FacilitiesActions.dectivate_facilty_admin(response));
}
function uploadFacilityImage(dispatch, response) {
    dispatch(FacilitiesActions.upload_Facility_Image(response));
}
function deactivatefacility(dispatch, response) {
    dispatch(FacilitiesActions.deactive_facility(response));
}
function getHighestDegrees(dispatch, response) {
    dispatch(UserActions.get_highestDegrees(response));
}
function getProfessionalRoles(dispatch, response) {
    dispatch(UserActions.get_professionalRoles(response));
}
function getEthnicities(dispatch, response) {
    dispatch(UserActions.get_ethnicities(response));
}
function deleteUniqewQs(dispatch, response) {
    dispatch(QuestionnaireActions.questionnaire());
    dispatch(QuestionnaireActions.deleteUniqewQsData(response.data));
}


//Admin users
// deprecated need to remove
function get_patients_data(dispatch, response) {

    dispatch(PatientsActions.all_patients_data(response));
}

// deprecated need to remove
function get_staff_data(dispatch, response) {
    dispatch(PatientsActions.all_staff_data(response));
}

// USERS_BY_ROLE
function set_Users_By_Role(dispatch, response) {
    dispatch(UserActions.setUsersByRole(response));
}

function adminDashboard(dispatch, response) {
    dispatch(AdminDashboardActions.adminDashboard_data(response));
}

function getPatientinfo(dispatch, response) {
    dispatch(PatientsActions.get_patient_info_data(response));
}
function getRedFlagInfo(dispatch, response) {
    dispatch(PatientsActions.red_flag_Data(response));
}
function adminSelect(dispatch, response) {
    dispatch(AdminSettingAactions.adminSelect_data(response));
}

function adminDeactivateUser(dispatch, response) {
    dispatch(AdminSettingAactions.adminDeactivate_data(response));
}

// Response of all security questions API
function setAllSecrityQuestionsResponse(dispatch, response) {
    dispatch(SettingScreen.SetAllSecurityQuestions(response));
}
function setAllRandomSecurityQuestionsByIdResponse(dispatch, response) {
    dispatch(SettingScreen.setAllRandomSecurityQuestionsById(response));
}
// Response of User selected security questions update API
function updateSecrityQuestions_Status(dispatch, response) {
    dispatch(SettingScreen.setUpdateSecurityQuestionsStatus(response));
}

function activateDeactivateStaff(dispatch, response) {
    dispatch(SettingScreen.updateStaffSatusData(response));
}
function gettherpaistlist(dispatch, response) {
    dispatch(UserActions.therapist_list_Data(response));
}
function getpsychiatristlist(dispatch, response) {
    dispatch(UserActions.psychiatrist_list_Data(response));
}

function triggerTime(dispatch, response) {
    dispatch(UserActions.user_trigger_time(response));
}
function filterPatientdata(dispatch, response) {
    dispatch(UserActions.fillter_patient_data(response));
}
function fileUploadRegistration(dispatch, response) {
    dispatch(UserActions.setFileUploadRegistration(response));
}


//patient related reports
function send_self_care_data(dispatch, response) {
    dispatch(ReportActions.selfe_care_data(response));

}
function send_mythoughts_data(dispatch, response) {
    dispatch(ReportActions.mythoughts_data(response));

}

function send_myactivity_data(dispatch, response) {
    dispatch(ReportActions.myActivity_data(response));

}
function send_myaexperience_data(dispatch, response) {
    dispatch(ReportActions.myExperienceData(response));

}
function surveyResponse(dispatch, response) {
    dispatch(UserActions.surveyResponseData(response));
}

function sendCsvReportAdmin(dispatch, response) {
    dispatch(ReportActions.csv_report_admin_data(response));
}

function sendCsvReportSuperAdmin(dispatch, response) {
    dispatch(ReportActions.csv_report_super_admin_data(response));
}
function addquestionToSurvey(dispatch, response) {
    dispatch(QuestionnaireActions.adminUniqueQuestionAll_data(response));
    dispatch(UserActions.addquestionToSurvey_data(response));
}

function adminUniqueQuestionAll(dispatch, response) {
    dispatch(QuestionnaireActions.adminUniqueQuestionAll_data(response));
}

function logoutUserSession(dispatch, response) {
    dispatch(UserActions.setSessionLogout(response));
}
function SetAutoLogutTimeOut(dispatch, response) {

    //  dispatch(UserActions.setAutoLogOutTime(response));
}
function setResendLink(dispatch, response) {
    dispatch(FacilitiesActions.ResendLink(response));
}

function resloveRedFlags(dispatch, response) {
    dispatch(UserActions.user_redflag_reslove(response));
}

function resolvedReasons(dispatch, response) {
    console.log(response, 'response')
    // dispatch(ReasonActions.getReasons(response));
    dispatch(ReasonActions.get_reasons(response));
    // console.log(response, 'resres')
    // return{
    //     type : 'success respose',
    //     payload: response.data
    // }
}

function logsList(dispatch, response) {
    console.log(response, 'response getLogsList')

    dispatch(ReasonActions.getLogsList(response));

}

function logResponse(dispatch, response) {
    console.log(response, 'response postLogsResponse')

    dispatch(ReasonActions.postLogsResponse(response));

}

function resolvedPutReason(dispatch, response) {
    dispatch(ReasonActions.put_response(response));
}

function historyLogs(dispatch, response) {
    dispatch(ReasonActions.getResolvedRedFlagsHistory(response));

}

function deleteUserLogs(dispatch, response) {
    dispatch(UserActions.user_delete(response));

}

function userProfile(dispatch, response) {
    dispatch(UserActions.upload_User_Profile_Image(response));
}

function updateQuestionExpression(dispatch, response) {
    dispatch(QuestionnaireActions.updateExpression(response));
}

function updateWeeklySurvey(dispatch, response) {
    dispatch(QuestionnaireActions.surveyWeeklyUpdate(response));
}


/** WEBPACK FOOTER **
 ** ./src/base/success_manager.js
 **/